<template>
    <section>
      <div style="padding-top: 22px" v-if="addOns.documents" >
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div >
              <h1 class="title" style="color:#3e8ed0">Documents</h1>
              <h5 class="subtitle">Manage your documents here.</h5>
            </div>
          </div>
        </div>
        <b-table :data="tableData" striped
        :draggable="role !== 'viewer'"
         @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave">
          <template slot-scope="props">
            <b-table-column centered>
              <b-icon icon="grip-vertical">
              </b-icon>
            </b-table-column>
            <b-table-column field="title" label="Title"  class="topPadding" centered>
              {{props.row.title}}
            </b-table-column>
            <b-table-column field="description" label="Description"  class="topPadding" centered>
              {{props.row.desc}}
            </b-table-column>
            <b-table-column field="url" label="File"  class="topPadding" centered>

<a :href="props.row.url" target="_blank" style="width:1px;height:1px;padding-left: 5px">{{props.row.fileName}}</a>
            </b-table-column>
            <b-table-column field="editDelete" label="Edit/Delete"  class="topPadding" centered>
              <b-button icon-left="edit" @click="editDocumentModal(props.index)" class="button is-info is-small"></b-button>
              <b-button :disabled="role === 'viewer'" icon-left="trash" @click="deleteDocumentDialog(props.index)" class="button is-danger is-small">
                </b-button>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div v-else class="container">
      </div>
      <vue-fab v-if="!bAddDocument" title="Add document" :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big" @clickMainBtn="addDocumentModal" :hidden="role === 'viewer'"/>
    </section>
  </template>

<script>
import DocumentAddEdit from '@/components/documents/DocumentAddEdit'

export default {
  name: 'Documents',
  data: () => {
    return {
      tableData: [],
      autoHide: false,
      deleteFile: 0,
      loadingComponent: null,
      draggingRowIndex: null,
      bAddDocument: false
    }
  },
  computed: {
    addOns () {
      return this.$store.state.addOns
    },
    documents () {
      return this.$store.state.documents
    },
    role () {
      return this.$store.state.role
    }
  },
  watch: {
    documents () {
      this.tableData = []
      this.setTableData()
    }
  },
  mounted: function () {
    if (this.documents) {
      this.setTableData()
    }
  },
  methods: {
    setTableData () {
      for (let doc in this.documents) {
        this.tableData.push({ id: doc, ...this.documents[doc] })
      }
      this.tableData.sort((a, b) => (a.order !== undefined ? a.order : 0) - (b.order !== undefined ? b.order : 0))
    },
    addDocumentModal () {
      if (this.role !== 'viewer') {
        this.bAddDocument = true
        this.$buefy.modal.open({
          parent: this,
          component: DocumentAddEdit,
          props: { propParentFn: this.cancelAdd },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    editDocumentModal (id) {
      this.bAddDocument = true
      this.$buefy.modal.open({
        parent: this,
        component: DocumentAddEdit,
        props: { propItem: this.tableData[id], propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    deleteDocumentDialog (id) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure that you want to delete document "' + this.tableData[id].title + '"?',
        cancelText: 'No',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          this.deleteDocument(id)
        }
      })
    },
    deleteDocument (id) {
      this.loadingComponent = this.$buefy.loading.open()

      let documentId = this.tableData[id].id
      let resourceName = this.tableData[id].fileName

      this.deleteFile = true

      // check if file is used by another document
      for (let docId in this.documents) {
        if (docId !== documentId) {
          if (this.documents[docId].fileName === resourceName) {
            this.deleteFile = false
          }
        }
      }

      if (this.deleteFile) {
        this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Documents/' + resourceName).delete()
          .then(() => {
            this.$store.state.database.ref('/neoslide/documents/' + this.$store.state.workspaceId + '/' + documentId).remove()
              .then(() => {
                this.loadingComponent.close()
              })
              .catch(error => {
                this.loadingComponent.close()
                this.globalLogger('could not remove document', error)
                this.showAlert()
              })
          })
          .catch(error => {
            this.loadingComponent.close()
            this.globalLogger('could not delete previous file', error)
            this.showAlert()
          })
      } else {
        this.$store.state.database.ref('/neoslide/documents/' + this.$store.state.workspaceId + '/' + documentId).remove()
          .then(() => {
            this.loadingComponent.close()
          })
          .catch(error => {
            this.loadingComponent.close()
            this.globalLogger('could not remove document', error)
            this.showAlert()
          })
      }
    },
    showAlert () {
      this.$buefy.dialog.alert({
        title: 'Operation faild',
        message: 'Deleting document failed. Please try again.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    cancelAdd () {
      this.bAddDocument = false
    },
    saveOrder () {
      const workspaceId = this.$store.state.workspaceId
      const database = this.$store.state.database

      const promises = this.tableData.map(doc => {
        return database.ref(`neoslide/documents/${workspaceId}/${doc.id}/order`).set(doc.order)
      })

      Promise.all(promises)
        .then(() => {
          this.globalLogger('orders updated')
        })
        .catch(error => {
          this.handleError(error)
        })
    },
    dragstart (payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover (payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')

      const from = this.draggingRowIndex
      const to = payload.index

      if (from === to) return

      const movedItem = this.tableData.splice(from, 1)[0]
      this.tableData.splice(to, 0, movedItem)

      this.tableData.forEach((doc, index) => {
        doc.order = index
      })

      this.draggingRowIndex = null

      this.saveOrder()
    }
  }
}
</script>
<style scoped>
.topPadding {
  padding-top: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/documents/Documents.vue